const ProdEnv = {
  name: "prod",
  baseUrl: "https://hydra.brightmoney.co/api/v0",
  sentryKey: "https://05bf9c29ed1d4c608118fd9fe7b4a900@sentry.io/1731022",
  firebaseConfig: {
    apiKey: "AIzaSyDdY8D-BqtVQwIwx0hgFanoq_l4h5ry_og",
    authDomain: "brightcapitalapp.firebaseapp.com",
    databaseURL: "https://brightcapitalapp.firebaseio.com",
    projectId: "brightcapitalapp",
    storageBucket: "brightcapitalapp.appspot.com",
    messagingSenderId: "277480012758",
    appId: "1:277480012758:web:6c7fc8c70e188c25768277",
  },
};

const DevEnv = {
  name: "dev",
  baseUrl: "https://api.brightadvisor.co",//"https://qa-brightadv-gateway.brightmoney.co",
  sentryKey: "https://b8fc120e7fff4ec4a39dc38265780cf6@sentry.io/1895190",
  firebaseConfig: {
    apiKey: "AIzaSyC-ycTyCBZd1I4Q7nZnyWIWa5xCcNam4oI",
    authDomain: "brightcapitaladvisor.firebaseapp.com",
    projectId: "brightcapitaladvisor",
    storageBucket: "brightcapitaladvisor.appspot.com",
    messagingSenderId: "358184929726",
    appId: "1:358184929726:web:efd7fb0a9a1c02732211ef",
    measurementId: "G-J1W5491XR4"
    // apiKey: "AIzaSyBo8-IqtYgwE6Pdseuvkqc0wUxOFVGqwi8",
    // authDomain: "brightcapitalapp-dev.firebaseapp.com",
    // databaseURL: "https://brightcapitalapp-dev.firebaseio.com",
    // projectId: "brightcapitalapp-dev",
    // storageBucket: "brightcapitalapp-dev.appspot.com",
    // messagingSenderId: "382800015619",
    // appId: "1:382800015619:web:8523858b354c00907af936",
  },
};

const StagingEnv = {
  name: "staging",
  baseUrl: "https://hydra-dev-4.brightmoney.co/api/v0",
  sentryKey: "https://b8fc120e7fff4ec4a39dc38265780cf6@sentry.io/1895190",
  firebaseConfig: {
    apiKey: "AIzaSyBo8-IqtYgwE6Pdseuvkqc0wUxOFVGqwi8",
    authDomain: "brightcapitalapp-dev.firebaseapp.com",
    databaseURL: "https://brightcapitalapp-dev.firebaseio.com",
    projectId: "brightcapitalapp-dev",
    storageBucket: "brightcapitalapp-dev.appspot.com",
    messagingSenderId: "382800015619",
    appId: "1:382800015619:web:8523858b354c00907af936",
  },
};

let env = DevEnv;
if (process.env.REACT_APP_ENV === "production") {
  env = ProdEnv;
} else if (process.env.REACT_APP_ENV === "staging") {
  env = StagingEnv;
}

const DEFAULTS = {
  env: env.name,
  validCountries: ["US"],
  baseUrl: env.baseUrl, //"https://hydra.brightmoney.co/api/v0", //"http://ec2-44-227-0-215.us-west-2.compute.amazonaws.com/api/v0", //"https://www.brightmoney.co/api/v1/website",
  middleUrl: '/api/v1/ba_mfp_client',
  sentryKey: env.sentryKey,
  firebaseConfig: DevEnv.firebaseConfig,
  app: {
    phonePrefix: "+1",
  },
  apis: {
    login: "/login/",
    profileUpdate: "/profile_data/",
    dashboard: "/dashboard/"
  },
  routes: {
    loading: "",
    login: "/login",
    otp: "/otp",
    name: "/name",
    email: "/emailaddress",
    dob: "/dob",
    address: "/address",
    annualIncome: "/annualincome",
    liquidAssets: "/liquidAssets",
    citizenship: "/citizenship",
    ssn: "/ssn",
    kyc2: "/kyc2",
    kyc3: "/kyc3",
    riskQuestionnaire: "/riskQuestionnaire",
    riskRecommendation: "/riskRecommendation",
    accountFundingSource: "/accountFundingSource",
    bankinginfo: "/bankinginfo",
    disclosures: "/disclosures",
    accountOpenWait: "/accountOpenWait",
    kycFail: "/kycFail",
    accountOpenSuccess: "/accountOpenSuccess",
    buyWait: "/buyWait",
    buySuccess: "/buySuccess",
    fundingFail: "/fundingFail",
    showHoldings: "/showHoldings",
    networkError: "/networkError",
  },
};

export default DEFAULTS;
